module.exports = __webpack_public_path__ + "02303fb8189e2d9c7cce2f8bd54ea135.jpg";